


var immo = {
	rf : $('#renderframe'),
	init : function(){
		var self = this;

		$.getJSON('/wp-content/uploads/loadfile/fbloadfile_import.json', function(data){
			for(var i=0;i<data.length;i++){
				data[i]['source'] = 'bauvereinag';
			}
			var properties = shuffleArray(data);
			// Zum Rendern schicken
			properties.forEach(function (property) {
				self.render(property);
			});
		}, function(){

		});

	},
	render : function(property) {
		var self = this;
		var baseURL = 'https://www.bauvereinag.de';
		var logo = 'logo_bv.png';
		var href = baseURL+'/kunde-werden/mietimmobilien-suchen/immobilie?id='+property.AnbieterObjektID+'#pk_campaign=DarmstadtImHerzen&pk_kwd='+property.AnbieterObjektID;
		if (property.source == 'heagwohnbau') {
			var baseURL = 'https://www.heagwohnbau.de';
			var logo = 'logo_hwb.png';
			var href = baseURL+'/wohnen-mieten/aktuelle-mietangebote/immobiliendetails?id='+property.AnbieterObjektID;
		}
		var html = '';
		html += '<div id="'+property.id+'" class="rowitem article pad-no property">';

		html += '<a target="_blank" class="rowitem--link pad-no" href="'+href+'" title="'+property.headline+'">';
		var image = property.Bild;
		if (property.Bild[0] == ' ') image = property.Bild.slice(1);
		var imageURL = '/wp-content/uploads/loadfile/imgs/'+image;
		html += '<div class="rowitem--innerRow">';
		html += '<div class="property--logo"><img src="/wp-content/themes/darmstadtimherzen/css/images/immo/'+logo+'" alt="BauvereinAG Logo"></div>';
		html += '<img alt="Tag der Stadtwirtschaft" class="rowitem--image" src="'+imageURL+'"></div>';
		html += '<div class="rowitem--innerRow pad-text">';
		html += '<h4 class="rowitem--title">'+property.headline+'</h4><br>';
		html += '<p class="rowitem--description">'+property.Ort+', '+property.Strasse+' '+property.Hausnummer+'</p>';
		if (property.el_id == 22) {
			html += '<hr><p>Monatliche Miete: <strong class="property-price">€ '+property.Miete+'</strong></p>';
		} else if (property.el_id == 3) {
			html += '<hr><p>Kaltmiete: <strong class="property-price">€ '+property.Miete+'</strong></p>';
		}
		// html += '<a target="_blank" class="btn" href="'+href+'" title="Mehr Informationen">'+property.Ort+', '+property.Strasse+' Mehr Informationen</a>';
		html += '</div>';
		html += '</a>';
		html += '</div>';
		self.rf.append(html);
	}
}


function shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
	return array;
}
